import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import CustomBackdrop from './CustomBackdrop';
import CloseIconSvg from '../../assets/icons/closeIcon.svg';
import DeleteIconSvg from '../../assets/icons/deleteIconPopup.svg';
import useCommonMediaQuery from '../../hooks/useCommonMediaQuery';

const DeleteConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Are you sure you want to delete the Announcement?',
}) => {
  const isMobileFullscreen = useCommonMediaQuery('sm');

  return (
    <>
      <CustomBackdrop
        open={open}
        modalDialogSelector=".delete-confirmation-modal-dialog, .MuiDialog-root"
        blurIntensity={4}
        zIndex={10002}
      />
      <Dialog
        open={open}
        onClose={(e, reason) => {
          if (reason !== 'backdropClick') onClose();
        }}
        maxWidth="xs"
        fullWidth
        fullScreen={isMobileFullscreen}
        hideBackdrop
        disableScrollLock
        disableEnforceFocus
        className="delete-confirmation-modal-dialog"
        sx={{ zIndex: 10002 }}
        PaperProps={{
          sx: {
            zIndex: 10002,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxShadow:
              '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            ...(isMobileFullscreen
              ? {
                  m: 0,
                  height: '100%',
                  maxHeight: '100%',
                  borderRadius: 0,
                  maxWidth: '100%',
                  width: '100%',
                }
              : {
                  width: '100%',
                  maxWidth: 400,
                  borderRadius: 3,
                }),
          },
        }}
      >
        <DialogContent
          sx={{
            position: 'relative',
            p: { xs: 2.5, sm: 3 },
            pt: { xs: 5, sm: 3 },
            textAlign: 'center',
            flex: isMobileFullscreen ? 1 : undefined,
            minHeight: 0,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: isMobileFullscreen ? 'center' : 'flex-start',
          }}
        >
          <Box sx={{ position: 'absolute', top: 12, right: 12, zIndex: 1 }}>
            <IconButton
              onClick={onClose}
              sx={{
                color: '#6b7280',
                p: 0,
                borderRadius: '50%',
                width: '35px',
                height: '35px',
              }}
            >
              <img src={CloseIconSvg} alt="Close" width={35} height={35} />
            </IconButton>
          </Box>
          <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
            <Box
              sx={{
                width: { xs: 52, sm: 60 },
                height: { xs: 52, sm: 60 },
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                mb: 1.5,
              }}
            >
              <img
                src={DeleteIconSvg}
                alt="Delete"
                width={35}
                height={35}
                style={{ maxWidth: '100%', height: 'auto' }}
              />
            </Box>
          </Box>
          <Typography
            variant="h6"
            sx={{
              mb: 0,
              color: '#1f2937',
              fontWeight: 500,
              fontSize: { xs: '0.95rem', sm: '1rem' },
              lineHeight: 1.5,
              textAlign: 'center',
              wordBreak: 'break-word',
              maxWidth: '100%',
              px: { xs: 1, sm: 2 },
            }}
          >
            {title}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            p: { xs: 1.5, sm: 2 },
            pt: { xs: 1.5, sm: 1.5 },
            justifyContent: 'center',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: { xs: 1.5, sm: 1.5 },
            flexShrink: 0,
            borderTop: '1px solid #e5e7eb',
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            size="small"
            sx={{
              borderColor: '#d1d5db',
              color: '#374151',
              textTransform: 'none',
              fontWeight: 500,
              minWidth: { xs: 0, sm: 120 },
              padding: '4px 12px !important',
              '&:hover': {
                borderColor: '#9ca3af',
                backgroundColor: 'rgba(107, 114, 128, 0.05)',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#486791',
              color: 'white',
              textTransform: 'none',
              fontWeight: 500,
              minWidth: { xs: 0, sm: 120 },
              padding: '4px 12px !important',
              boxShadow: '0 4px 6px rgba(72, 103, 145, 0.2)',
              '&:hover': {
                backgroundColor: '#3d5a7a',
                boxShadow: '0 6px 8px rgba(72, 103, 145, 0.3)',
              },
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default DeleteConfirmationModal;
